__turbopack_context__.v({
  "className": "headlinefontloader_b21113a8-module__J9BUdG__className",
  "variable": "headlinefontloader_b21113a8-module__J9BUdG__variable",
});
